// extracted by mini-css-extract-plugin
module.exports = {"startup__stages":"styles-module--startup__stages--1SVq8","startup__opt":"styles-module--startup__opt--2e6QA","startup__space":"styles-module--startup__space--1s5c2"};